var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "el-form-item",
        { attrs: { label: _vm.showLabel ? _vm.labelTitle : "" } },
        [
          _c(
            "el-select",
            {
              ref: "ykSelectlazyload",
              staticClass: "search-item filter-item",
              staticStyle: { width: "100%" },
              attrs: {
                clearable: "",
                "collapse-tags": _vm.isMultiple,
                multiple: _vm.isMultiple,
                filterable: "",
                size: "small",
                "filter-method": _vm.filtermethod,
                placeholder: _vm.placeholder,
                "reserve-keyword": "",
                loading: _vm.loading,
                "value-key": _vm.propsValue,
                disabled: _vm.disabled,
              },
              on: {
                change: _vm.change,
                clear: _vm.clearSelector,
                "visible-change": _vm.visibleChangeSelector,
              },
              model: {
                value: _vm.selectEle,
                callback: function ($$v) {
                  _vm.selectEle = $$v
                },
                expression: "selectEle",
              },
            },
            _vm._l(_vm.list, function (item) {
              return _c("el-option", {
                key: item[_vm.propsValue],
                attrs: {
                  label: item[_vm.propsLabel],
                  value: _vm.isObjType ? item : item[_vm.propsValue],
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }